import React from 'react';
import { connect } from 'react-redux';
import { Layout, Sidebar } from 'react-admin';
import AppBar from './AppBar';
import Menu from './Menu';
import TopMenu from './TopMenu';
import useTopMenu from './useTopMenu';
import { darkTheme, lightTheme } from './themes';

/**
 * In top-menu mode the sidebar is hidden with CSS rather than removed.
 *
 * That is deliberate: Menu.js owns the inactivity auto-logout timer, and
 * react-admin renders the menu as a child of the Sidebar. Returning null
 * here would unmount Menu and silently kill the idle logout.
 */
const CustomSidebar = props => {
    const hidden = useTopMenu();

    return (
        <div style={hidden ? { display: 'none' } : undefined}>
            <Sidebar {...props} />
        </div>
    );
};

/**
 * react-admin renders `children` inside its content area, immediately below
 * the app bar. Prepending the horizontal menu there puts it on its own full
 * width row under the app bar, instead of competing for space inside it.
 */
const Content = ({ children }) => {
    const showTop = useTopMenu();

    return (
        <React.Fragment>
            {showTop && <TopMenu />}
            {children}
        </React.Fragment>
    );
};

const CustomLayout = ({ children, ...props }) => (
    <Layout {...props} appBar={AppBar} sidebar={CustomSidebar} menu={Menu}>
        <Content>{children}</Content>
    </Layout>
);

export default connect(
    state => ({
        theme: state.theme === 'dark' ? darkTheme : lightTheme,
    }),
    {}
)(CustomLayout);
